<template>
  <div class="login-box" v-show="resetPasswordAccessGranted">
    <logo></logo>
    <div class="login-box-body">
      <p class="login-box-msg">
        <span v-if="isFirstReset">{{ $t('reset_password.title.first_attempt') }}</span>
        <span v-else>{{ $t('reset_password.title.next_attempt') }}</span>
      </p>
      <p class="alert alert-danger text-center" role="alert" v-show="resetPasswordFailed">{{ $t('reset_password.failed')
        }}</p>
      <p class="alert alert-danger text-center" role="alert" v-show="passwordsAreNotSame">{{
        $t('reset_password.password_not_same') }}</p>
      <form>
        <div class="form-group has-feedback" :class="{ 'has-error': passwordHasError }">
          <input type="password" id="password" name="password" class="form-control" required="required"
                 :placeholder="$t('general.password')" v-model="password"/>
          <span class="help-block" v-show="passwordHasError">{{ $t('reset_password.specify_password') }}</span>
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback" :class="{ 'has-error': confirmationHasError }">
          <input type="password" id="confirmation" name="confirmation" class="form-control" required="required"
                 :placeholder="$t('reset_password.confirm_password')" v-model="confirmation"/>
          <span class="help-block"
                v-show="confirmationHasError">{{ $t('reset_password.please_confirm_password') }}</span>
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" class="btn btn-primary btn-block btn-flat" @click.prevent="resetPassword">
              {{ $t('general.validate') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '../components/common/Logo'
import { mapState, mapActions } from 'vuex'

// noinspection JSUnusedGlobalSymbols
export default {
  created: function () {
    this.checkAuthorizationResetPassword({ id: this.$route.params.id, token: this.$route.params.token })
  },
  data () {
    return {
      password: '',
      confirmation: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('user', [
      'resetPasswordAccessGranted',
      'resetPasswordFailed'
    ]),
    passwordHasError: function () {
      return this.submitted && this.password === ''
    },
    confirmationHasError: function () {
      return this.submitted && this.confirmation === ''
    },
    passwordsAreNotSame: function () {
      return this.submitted && this.password !== this.confirmation
    },
    isFirstReset: function () {
      return this.$route.query.create !== undefined
    }
  },
  methods: {
    ...mapActions('user', {
      handleResetPassword: 'resetPassword',
      checkAuthorizationResetPassword: 'checkAuthorizationResetPassword'
    }),
    resetPassword: function () {
      this.submitted = true

      if (!this.passwordHasError && !this.confirmationHasError && !this.passwordsAreNotSame) {
        this.handleResetPassword({
          id: this.$route.params.id,
          token: this.$route.params.token,
          lawFirmId: this.$route.query.law_firm_id,
          password: this.password,
          isFirstReset: this.isFirstReset
        })
      }
    }
  },
  components: {
    Logo
  }
}
</script>
